import { writable } from 'svelte/store';
import { HubService } from './HubService';

export const hubStore = writable<HubService | null>(null);
